// eslint is dumb and wants you to use default export if only exporting one thing.
// eslint-disable-next-line import/prefer-default-export
export const stripeNonSecretKey = (() => {
  if (process.env.REACT_APP_STAGE === 'prod') return 'pk_live_ujpW5UrqohZfsCWqh9MYvbHr';
  if (process.env.REACT_APP_STAGE === 'development-webhooks') return 'pk_test_gjmnOupRng7xpXKGXnTKWMhI00NNnITtyp';
  return 'pk_test_RGGf56EzKDkbOpJzkvb18rw7';
})();
